import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'

import { useModuleIds } from 'portal/lib/hooks'
import { icons, ColourButton, Spacer, Label } from 'portal/lib/primitives'
import { trackMixpanel } from 'portal/store/mixpanel/actions'

import { RecordHistoryDrawer } from './RecordHistoryDrawer'

export function RecordHistoryButton({ children = 'Record history', ...props }) {
  const [open, setOpen] = useState(false)
  const isInitialMount = useRef(true)

  const { accountId, projectId, moduleName, recordId } = useModuleIds()

  const dispatch = useDispatch()

  const EV_HISTORY_OPENED = 'frontend_records_history_opened'
  const EV_HISTORY_CLOSED = 'frontend_records_history_closed'

  useEffect(() => {
    // Don't track the initial mount
    if (isInitialMount.current) {
      isInitialMount.current = false
    } else {
      dispatch(
        trackMixpanel(open ? EV_HISTORY_OPENED : EV_HISTORY_CLOSED, {
          project_id: projectId,
          account_id: accountId,
          moduleName: moduleName?.toLowerCase(),
          record_id: recordId
        })
      )
    }
  }, [accountId, dispatch, moduleName, open, projectId, recordId])

  const handleOnClick = event => {
    setOpen(true)
    event.target.blur()
  }

  return (
    <>
      <ColourButton.Basic
        id="RecordHistoryButton"
        {...props}
        onClick={handleOnClick}
      >
        <icons.History colour="currentColor" />

        <Spacer.Fine />

        <Label isChild colour="inherit">
          {children}
        </Label>
      </ColourButton.Basic>

      <RecordHistoryDrawer
        open={open}
        setOpen={setOpen}
        moduleName={moduleName}
      />
    </>
  )
}
